import React from "react";
import CheckMarkBlue from "../../resources/check-mark-blue.svg";
import CheckMarkWhite from "../../resources/check-mark-white.svg";

const CheckBox = (props) => {
  // Indeterminate represents a mixed/partial selection, such as when only some
  // items in a group are selected. It renders a dash instead of a checkmark.
  const isSelected = props.checked || props.indeterminate;

  return (
    <div
      className={`flex flex-row cursor-pointer ${props.className ?? "mr-5 my-2.5"}`}
      onClick={props.onClick}
      style={{ printColorAdjust: "exact" }}
      data-testid={props.testId}
      data-checked={props.checked ? 1 : 0}
      data-indeterminate={props.indeterminate ? 1 : undefined}
    >
      {isSelected ? (
        <div
          className={`flex h-5 w-5 border-2 rounded ${
            props.lightMode
              ? "border-snow-white bg-snow-white"
              : "border-snow-primary bg-snow-primary"
          } items-center justify-center`}
        >
          {props.indeterminate ? (
            <span
              className={`h-0.5 w-2.5 ${
                props.lightMode ? "bg-snow-primary" : "bg-snow-white"
              }`}
            />
          ) : (
            <img
              src={props.lightMode ? CheckMarkBlue : CheckMarkWhite}
              alt="checkmark"
            />
          )}
        </div>
      ) : (
        <div
          className={`h-5 w-5 border-2 rounded ${
            props.lightMode ? "border-snow-white" : "border-snow-primary"
          }`}
        />
      )}
      {props.label && (
        <div
          className={`ml-1.5 text-base leading-5 ${
            props.lightMode ? "text-snow-white" : "text-snow-primary"
          } ${props.labelMargin ? "ml-6" : null}`}
        >
          {props.label}
        </div>
      )}
      {props.name ? (
        <>
          <input type="hidden" name={props.name} value={props.checked} />
        </>
      ) : null}
    </div>
  );
};
export default CheckBox;
